// 登出按鈕
import { useDispatch } from 'react-redux';
import { userLogout } from '@/slices/userSlice';
import authClient from '@/common/apiClient/authClient';

const LogoutButton = ({ t }) => {
    const dispatch = useDispatch();
    // 登出
    const onLogout = async () => {
        try {
            const result = await authClient.logout();
            if (result) dispatch(userLogout());
        } catch (e) {
            console.error(e);
        }
    };

    return (
        <button
            onClick={onLogout}
            className="text-btn1 text-white rounded-[4px] py-[12px] text-center block w-full trans bg-bou hover:bg-white hover:text-bou"
        >
            {t('LOGOUT')}
        </button>
    );
};

export default LogoutButton;
